var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countries_all"},[_c('the-table',{attrs:{"headers":_vm.headers,"tableName":"price_offers","showFilter":false},on:{"expandFired":_vm.mapItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }